import React from 'react';
import { Divider, Grid } from 'semantic-ui-react';
import ButtonLink from 'components/ButtonLink';
import { SprayEventWizardStep } from 'services/sprayEventWizard/types';
import { setSprayEventWizardStep } from 'services/sprayEventWizard/actions';
import { connect } from 'react-redux';

export interface OwnProps {
    title: string;
    sprayEventWizardStep?: SprayEventWizardStep;
    children: React.ReactElement;
    readOnly: boolean;
    last?: boolean;
}

interface DispatchProps {
    setSprayEventWizardStep: typeof setSprayEventWizardStep;
}

type Props = OwnProps & DispatchProps;

export class WizardEventSummarySectionComponent extends React.PureComponent<Props> {
    setSelectedStep = (): void => {
        const { props } = this;
        const { sprayEventWizardStep } = props;

        props.setSprayEventWizardStep(sprayEventWizardStep || 0);

        const modal = document.getElementsByClassName('modal fullscreen')[0];

        if (modal) {
            // Fullscreen modal can get quite long heigh, so we scroll back to the top
            modal.scrollIntoView();
        }
    };

    renderEditButton(): React.ReactElement | null {
        const { sprayEventWizardStep, readOnly } = this.props;

        if (readOnly) return null;

        if (sprayEventWizardStep || sprayEventWizardStep === 0) {
            return (
                <Grid.Column width="4" textAlign="right">
                    <ButtonLink
                        buttonProps={{ primary: true, type: 'button' }}
                        onClick={this.setSelectedStep}
                    >
                        Edit
                    </ButtonLink>
                </Grid.Column>
            );
        }

        return null;
    }

    render(): React.ReactElement {
        const { title, children, last = false } = this.props;

        const classnames = `spray-event-summary-section ${last ? 'last' : ''}`;

        return (
            <Grid className={classnames}>
                <Grid.Row>
                    <Grid.Column width="12">
                        <h5 className="spray-event-summary-section-title">
                            {title}
                        </h5>
                    </Grid.Column>
                    {this.renderEditButton()}
                </Grid.Row>
                <Divider />
                <Grid.Row className="spray-event-summary-section-content">
                    <Grid.Column>{children}</Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

export default connect(null, {
    setSprayEventWizardStep
})(WizardEventSummarySectionComponent);
